var _path, _circle, _polygon, _path2, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _polygon2, _path9, _polygon3, _polygon4, _path0, _circle3, _path1, _path10, _path11, _path12, _path13, _path14, _polygon5, _path15, _rect, _circle4, _path16, _rect2, _rect3, _rect4, _circle5, _rect5, _path17, _path18, _path19, _path20, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4e5ac1e-f7c3-49db-bea6-73c2d2e1dfe0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 888,
    height: 580.72337,
    viewBox: "0 0 888 580.72337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mobile_development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.55839,539.72318s10.80448,17.13628,6.94581,21.776,28.94959,4.75576,28.94959,4.75576-4.92815-24.9281-3.4777-30.665Z",
    transform: "translate(-156 -159.63832)",
    fill: "#ffb8b8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.82548,
    cy: 352.4157,
    r: 33.87953,
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "245.51 536.052 245.51 556.137 265.594 551.952 263.921 537.726 245.51 536.052",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M472.64248,699.03783l56.06912,9.20538-14.2265,20.92131s-39.33207-13.38964-49.3743-13.38964S472.64248,699.03783,472.64248,699.03783Z",
    transform: "translate(-156 -159.63832)",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.44089,658.86891s41.84263-48.53745,55.23227-46.02689,19.24761,17.5739,19.24761,17.5739l7.53167,74.47988s-26.77928,2.51055-26.77928,0-5.02112-56.06912-5.02112-56.06912S356.32,735.85934,335.39866,678.11652Z",
    transform: "translate(-156 -159.63832)",
    fill: "#d0cde1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.65584,691.50616s.83685,43.84262,25.94243,46.35318,52.7217-18.737,52.7217-18.737l45.19-21.64944s53.55856,28.34426,69.45876,20.81259c0,0,16.73705-17.57391,5.858-22.595s-.83685,0-.83685,0l-64.43765-33.4741s-12.55279-3.34741-34.31095,5.858-51.048,13.38964-51.048,13.38964Z",
    transform: "translate(-156 -159.63832)",
    fill: "#d0cde1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.49846,
    cy: 363.66048,
    r: 25.10558,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M355.48312,593.59441l-1.6737,35.14781s.83685,46.02689-6.69482,49.3743c-3.80767,1.6904-11.45652,5.088-18.52793,8.80365-5.30562,2.77836-10.2849,5.72409-13.06326,8.25978a9.36818,9.36818,0,0,0-1.88291,2.18417c-3.34741,5.858-25.10558,5.02112-30.1267.83686s-1.6737,5.02111-5.858,6.69482c-4.05039,1.62349-9.66564-11.649-6.22619-31.46569.1088-.66109.23435-1.33057.36822-2.00841,3.84117-19.20578-2.19255-65.20759-1.26366-82.98233a31.2726,31.2726,0,0,1,.42681-4.05034c2.51055-13.38964,34.54529-40.63755,40.53714-29.03041,7.381,14.32691,24.33568,1.23852,27.24791-5.28054,16.73705-.83685,22.595,19.24761,22.595,19.24761Z",
    transform: "translate(-156 -159.63832)",
    fill: "#44bba4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M423.26818,708.24321s-13.38964,5.02111-17.57391,4.18426-8.36852,2.51056-8.36852,7.53167-5.02112,16.737,2.51056,17.57391,38.49521-.83686,45.19,1.6737c0,0,30.12669.83685,27.61614-11.71593s-15.06335-11.71594-15.06335-11.71594S423.26818,714.10117,423.26818,708.24321Z",
    transform: "translate(-156 -159.63832)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M521.17992,710.75376s1.67371-5.02111,4.18427-5.02111,22.595,3.34741,25.10557,2.51056,31.8004-2.51056,26.77928,11.71593-21.75816,15.9002-21.75816,15.9002-30.12669-3.34741-34.311-2.51056-19.24761,0-16.73705-4.18426S522.85363,717.44858,521.17992,710.75376Z",
    transform: "translate(-156 -159.63832)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M445.00463,590.55116l4.59111,18.93835a1.18275,1.18275,0,0,1-.023.6392L428.7465,675.21078a1.18288,1.18288,0,0,1-2.30193-.22695l-2.88107-25.35342a1.18282,1.18282,0,0,1,.05063-.5l19.11622-58.667A1.18289,1.18289,0,0,1,445.00463,590.55116Z",
    transform: "translate(-156 -159.63832)",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "287.316 432.512 291.555 448.761 273.186 508.105 268.947 489.737 287.316 432.512",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M350.76762,680.45975c.70648,2.11943,73.47331-.70647,74.17979-1.41294a15.33535,15.33535,0,0,0,1.55421-2.8259c.66413-1.413,1.27169-2.8259,1.27169-2.8259l-2.8259-22.87563L352.887,647.96194s-1.80154,19.38566-2.16892,28.259A21.19873,21.19873,0,0,0,350.76762,680.45975Z",
    transform: "translate(-156 -159.63832)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "259.763 493.975 261.176 513.757 229.385 513.757 229.385 493.975 259.763 493.975",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.788 500.334 218.978 500.296 218.081 508.811 200.419 508.811 200.419 500.334 218.788 500.334",
    opacity: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M350.76762,680.45975c.70648,2.11943,73.47331-.70647,74.17979-1.41294a15.33535,15.33535,0,0,0,1.55421-2.8259h-75.7835A21.19873,21.19873,0,0,0,350.76762,680.45975Z",
    transform: "translate(-156 -159.63832)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.43866,
    cy: 315.37883,
    r: 9.44184,
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M324.59935,485.29456s-9.64664,16.04562-32.07831,22.0523-.18324,39.71527-.18324,39.71527-8.09034-12.25767,3.57888-25.23887S326.3647,499.96712,324.59935,485.29456Z",
    transform: "translate(-156 -159.63832)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M328.58667,686.92017c-2.067,3.90814-4.49389,7.96685-4.90394,9.6071-.27618,1.113-3.339.46864-8.15932-1.34732-9.66563-3.65709-26.41944-12.03394-42.05184-20.41084a13.20191,13.20191,0,0,1-2.04192-1.339c.1088-.66109.23435-1.33057.36822-2.00841,3.84117-19.20578-2.19255-65.20759-1.26366-82.98233l7.12163-2.37663,14.22649,13.38964v56.906s36.82151,20.08446,39.33207,21.75817C332.49481,678.97007,330.729,682.86146,328.58667,686.92017Z",
    transform: "translate(-156 -159.63832)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M359.66738,641.295l22.595,11.71594s13.38964-14.22649,21.75817-3.34741S379.75185,663.89,379.75185,663.89s-28.453-6.69482-29.28984-15.9002S359.66738,641.295,359.66738,641.295Z",
    transform: "translate(-156 -159.63832)",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.009,672.25855l13.38964,3.34741S350.462,657.1952,366.36221,663.89s-20.08447,20.08446-20.08447,20.08446-19.2476,10.04223-26.77928,1.67371S322.009,672.25855,322.009,672.25855Z",
    transform: "translate(-156 -159.63832)",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M351.29886,561.794c.83685.83686,10.04223,7.53168,10.04223,7.53168s2.51056,31.80039-.83685,38.49521-5.858,6.69482-3.34741,10.04223,5.858.83686,2.51055,6.69482-6.69482,5.02112-4.18426,7.53168,1.67371,3.34741,1.67371,3.34741l10.04223,8.36852s-6.16116,9.81321-13.95966,9.09087-14.49333-38.38071-14.49333-38.38071Z",
    transform: "translate(-156 -159.63832)",
    fill: "#44bba4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M277.65584,581.87847l-7.53168,2.51056s-20.08446,73.643,3.34741,86.19581,49.3743,25.10558,50.21116,21.75817S333.725,675.606,331.2144,673.93225s-39.33207-21.75816-39.33207-21.75816v-56.906Z",
    transform: "translate(-156 -159.63832)",
    fill: "#44bba4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.953 452.785 131.28 492.954 175.633 513.876 134.627 492.954 132.953 452.785",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M934.39972,293.39833v65.68a2.29614,2.29614,0,0,1-2.29,2.29h-1.62989v342.15a35.702,35.702,0,0,1-35.70007,35.7H680.9898a35.69346,35.69346,0,0,1-35.69006-35.7v-330.15h-1.18005a1.6176,1.6176,0,0,1-1.62-1.61005V334.37837a1.61971,1.61971,0,0,1,1.62-1.62006h1.18005V318.67836h-1.19006a1.69647,1.69647,0,0,1-1.68994-1.7v-36.87a1.69432,1.69432,0,0,1,1.68994-1.69h1.19006v-19.22h-1.21008a1.498,1.498,0,0,1-1.5-1.5v-20.12a1.5066,1.5066,0,0,1,1.5-1.51h1.21008v-40.74a35.69136,35.69136,0,0,1,35.69006-35.69H894.77972a35.69991,35.69991,0,0,1,35.70007,35.69v95.78h1.62989A2.29609,2.29609,0,0,1,934.39972,293.39833Z",
    transform: "translate(-156 -159.63832)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 604.90335,
    y: 18.3068,
    width: 39.82343,
    height: 8.08642,
    rx: 2.54189,
    fill: "#e6e8ec"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.33477,
    cy: 22.35,
    r: 4.58665,
    fill: "#e6e8ec"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M913.38473,202.38814v504.09a22.65045,22.65045,0,0,1-22.65,22.64h-204.65a22.61062,22.61062,0,0,1-22.65-22.64v-504.09a22.64906,22.64906,0,0,1,22.65-22.65h30.63v3.93a18.65015,18.65015,0,0,0,18.65,18.65h104.08a18.6501,18.6501,0,0,0,18.65-18.65v-3.93h32.64A22.64266,22.64266,0,0,1,913.38473,202.38814Z",
    transform: "translate(-156 -159.63832)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 528.82677,
    y: 351.95881,
    width: 208,
    height: 27,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 528.82677,
    y: 399.95881,
    width: 208,
    height: 27,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 528.82677,
    y: 447.95881,
    width: 208,
    height: 27,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 713.82677,
    cy: 90.95881,
    r: 20,
    fill: "#44bba4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 528.40973,
    y: 157.95881,
    width: 208,
    height: 138,
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M767.2354,395.188c6.07317,22.45006,26.87512,36.35394,26.87512,36.35394s10.95541-22.49485,4.88225-44.94491-26.87512-36.35394-26.87512-36.35394S761.16224,372.738,767.2354,395.188Z",
    transform: "translate(-156 -159.63832)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M776.15949,390.36329c16.66485,16.22255,18.70034,41.1604,18.70034,41.1604s-24.98357-1.36412-41.64842-17.58667-18.70033-41.1604-18.70033-41.1604S759.49464,374.14073,776.15949,390.36329Z",
    transform: "translate(-156 -159.63832)",
    fill: "#44bba4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M822.48425,395.188c-6.07317,22.45006-26.87512,36.35394-26.87512,36.35394s-10.95541-22.49485-4.88225-44.94491S817.602,350.24314,817.602,350.24314,828.55741,372.738,822.48425,395.188Z",
    transform: "translate(-156 -159.63832)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M813.56016,390.36329c-16.66484,16.22255-18.70033,41.1604-18.70033,41.1604s24.98356-1.36412,41.64841-17.58667,18.70033-41.1604,18.70033-41.1604S830.225,374.14073,813.56016,390.36329Z",
    transform: "translate(-156 -159.63832)",
    fill: "#44bba4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 578.48265,
    width: 888,
    height: 2.24072,
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDev);
export default __webpack_public_path__ + "static/media/mobile-dev.2cf23fc27c06480ece3ebea5b155195f.svg";
export { ForwardRef as ReactComponent };